"use client";

import { CandidateLogoBase, type CandidateLogoBaseProps } from "./candidate-logo-base";

export type CompanyLogoProps = Omit<
  CandidateLogoBaseProps,
  "fallbackIcon" | "fallbackLabel"
>;

export function CompanyLogo(props: CompanyLogoProps) {
  return (
    <CandidateLogoBase
      fallbackIcon="IconBuildings"
      fallbackLabel="Company logo"
      {...props}
    />
  );
}
